package com.wintermar.inspection.core.ui.component

import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.size
import androidx.compose.material3.Icon
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextDecoration
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.painterResource

@Composable
fun LinkText(
    text: String,
    modifier: Modifier = Modifier,
    disabled: Boolean = false,
    icon: DrawableResource? = null,
    bold: Boolean = false,
    underline: Boolean = false,
    onClick: () -> Unit
) {
    Row(
        modifier = modifier.clickable(
            enabled = !disabled,
            indication = null,
            interactionSource = remember { MutableInteractionSource() },
            onClick = onClick
        ),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(
            LocalAppTheme.current.dimension.spacing.space1
        )
    ) {
        TextBodySmall(
            text = text,
            bold = bold,
            color = { it.brand },
            textDecoration = if (underline) TextDecoration.Underline else null
        )

        icon?.let {
            Icon(
                painter = painterResource(it),
                contentDescription = text,
                tint = LocalAppTheme.current.color.icon.brand,
                modifier = Modifier.size(LocalAppTheme.current.dimension.size.icon.s)
            )
        }
    }
}
